﻿import './faq.less'
import FAQs from '../components/faq';

const init = () => {
    const faqSetup = new FAQs();
}

if (document.readyState !== 'loading') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        init();
    });
}
